import * as PIXI from 'pixi.js';
import { tVector4 } from './ArrayHelper';

export interface IPointData {
    x: number;
    y: number;
}

export default class Point extends PIXI.Point implements IPointData {
    public clone(): Point {
        return new Point(this.x, this.y);
    }

    public copy(point: { x: number, y: number }) {
        this.set(point.x, point.y);
    }

    public static fromArray(point: [number, number]): Point {
        return new Point(point[0], point[1]);
    }
    
    public static add(pointA: IPointData, ...points: IPointData[]): Point {
        const total = Point.fromPointData(pointA);
        for (let i = 0; i < points.length; i++) {
            total.x += points[i].x;
            total.y += points[i].y;
        }

        return total;
    }

    public static subtract(pointA: IPointData, ...points: IPointData[]): Point {
        const total = Point.fromPointData(pointA);
        for (let i = 0; i < points.length; i++) {
            total.x -= points[i].x;
            total.y -= points[i].y;
        }

        return total;
    }

    public static inverse(point: IPointData): Point {
        return new Point(-point.x, -point.y);
    }

    public static distance(pointA: Point, pointB: Point): number {
        return Math.sqrt(Math.pow(pointB.x - pointA.x, 2) + Math.pow(pointB.y - pointA.y, 2));
    }

    public static get Zero(): Point {
        return new Point(0, 0);
    }

    public static get One(): Point {
        return new Point(1, 1);
    }

    public static get Center(): Point {
        return new Point(0.5, 0.5);
    }

    public static toVector4(point: IPointData): tVector4 {
        return [point.x, point.y, point.x, point.y];
    }

    public static fromVector4(value: tVector4): Point {
        return new Point(value[0], value[1]);
    }

    public static fromPointData(value: IPointData): Point {
        return new Point(value.x, value.y);
    }

    public static normalize(point: IPointData) {
        const d = Math.sqrt(point.x * point.x + point.y * point.y);

        if (d !== 0) {
            point.x = point.x / d;
            point.y = point.y / d;
        }
    }
}
